const PERMISSION_DENIED_KEYS = new Set([
	"PROJECT_PERMISSION_DENIED",
	"PROJECT.ACCESS_DENIED",
]);

/**
 * True when an API error indicates the user has no access to the project.
 * Accepts RTK Query errors, axios reject payloads, or slice error strings.
 */
export function isProjectAccessDenied(error) {
	if (!error) return false;

	if (typeof error === "string") {
		return PERMISSION_DENIED_KEYS.has(error);
	}

	const status = error.status ?? error.statusCode ?? error.data?.statusCode;
	if (status === 403) return true;

	const keys = [
		error.originalMessage,
		error.message,
		error.data?.originalMessage,
		error.data?.message,
	].filter(Boolean);

	return keys.some((key) => PERMISSION_DENIED_KEYS.has(key));
}

export default isProjectAccessDenied;
